// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"651":"7dfdacbd","659":"1d5c9201"}[chunkId] + ".chunk.js";
};